<template>
  <v-dialog v-model="dialog" max-width="1200px">
    <v-card>
      <v-card-title class="mx-3">
        {{ $t("Supplier.importResult.title") }}
        <v-spacer></v-spacer>
        <v-tooltip left>
          <template v-slot:activator="{ on, attrs }">
            <v-icon v-bind="attrs" v-on="on" @click="dialog = false">
              fa-times
            </v-icon>
          </template>
          {{ $t("$vuetify.close") }}
        </v-tooltip>
      </v-card-title>
      <v-divider />
      <v-card-text class="px-4 py-8 text-center subtitle-1">
        <v-data-table
                :headers="headers"
                :items="errorSupplier"
                multi-sort
                class="elevation-1 px-4 pt-2"
                disable-pagination
                hide-default-footer
                fixed-header
        >
          <template v-slot:item.supplier_code="{ item }">
            <span class="red--text" v-if="item.error_flg.includes('both_null') || item.error_flg.includes('code_null')">
              {{ $t("Supplier.importResult.codeNullError") }}
            </span>
            <span class="red--text" v-else-if="item.error_flg.includes('supplier_code')">
              {{ item.supplier_code }}
              <div>{{ item.error_msg.supplier_code }}</div>
            </span>
            <span v-else>
              {{ item.supplier_code }}
            </span>
          </template>
          <template v-slot:item.supplier_name="{ item }">
            <span class="red--text" v-if="item.error_flg.includes('both_null') || item.error_flg.includes('name_null')">
              {{ $t("Supplier.importResult.nameNullError") }}
            </span>
            <span v-else>
              {{ item.supplier_name }}
            </span>
          </template>
          <template v-slot:item.address="{ item }">
            <span class="red--text" v-if="item.error_flg.includes('address')">
              {{ item.error_msg }}
            </span>
            <span v-else>
              {{ item.province + item.city + item.area + item.address }}
            </span>
          </template>
          <template v-slot:item.manager_name="{ item }">
            <span class="red--text" v-if="item.error_flg.includes('manager_name_null')">
              {{ item.error_msg.manager_name_null }}
            </span>
            <span v-else>
              {{ item.manager_name }}
            </span>
          </template>
          <template v-slot:item.manager_tel="{ item }">
            <span class="red--text" v-if="item.error_flg.includes('manager_tel_null')">
              {{ item.error_msg.manager_tel_null }}
            </span>
            <span v-else>
              {{ item.manager_tel }}
            </span>
          </template>
        </v-data-table>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn color="secondary" outlined @click="dialog = false">
          {{ $t("$vuetify.close") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>

import {mapState} from "vuex";
import i18n from "@/i18n";

export default {
  name: "ImportExcelResultDialog",

  props: {
    value: Boolean,
    errorSupplier: Array
  },
  computed: {
    headers: () => [
      {
        text: i18n.t("Supplier.importResult.no"),
        align: "start",
        sortable: false,
        value: "no",
      },
      {
        text: i18n.t("Supplier.Fields.supplier_code"),
        align: "start",
        sortable: false,
        value: "supplier_code",
      },
      {
        text: i18n.t("Supplier.Fields.supplier_name"),
        align: "start",
        sortable: false,
        value: "supplier_name",
      },
      {
        text: i18n.t("Supplier.Fields.district_name"),
        align: "start",
        sortable: false,
        value: "city_1",
      },
      {
        text: i18n.t("Supplier.Fields.supplier_address"),
        align: "start",
        sortable: false,
        value: "address",
      },
      {
        text: i18n.t("Supplier.Fields.manager_name"),
        align: "start",
        sortable: false,
        value: "manager_name",
      },
      {
        text: i18n.t("Supplier.Fields.manager_tel"),
        align: "start",
        sortable: false,
        value: "manager_tel",
      }
    ],
    ...mapState(["loading", "settings"]),
  },
  data: () => ({
    dialog: false,
  }),
  methods: {

  },

  watch: {
    value: {
      immediate: true, //初始赋值也调用
      handler() {
        this.dialog = this.value;
      },
    },
    dialog: {
      handler() {
        this.$emit("input", this.dialog);
      },
    },
  },
};
</script>